// 1. FIX: Toast utility with missing 'info' method
// File: frontend/src/utils/toast.ts
import { toast as hotToast } from 'react-hot-toast';

export const toast = {
  // Existing methods from react-hot-toast
  success: hotToast.success,
  error: hotToast.error,
  loading: hotToast.loading,
  dismiss: hotToast.dismiss,
  remove: hotToast.remove,
  promise: hotToast.promise,
  custom: hotToast.custom,
  
  // ✅ ADDED: Missing info method
  info: (message: string, options?: any) => {
    return hotToast(message, {
      icon: 'ℹ️',
      style: {
        border: '1px solid #3b82f6',
        color: '#1e40af',
        backgroundColor: '#eff6ff'
      },
      ...options
    });
  },

  // ✅ ADDED: Warning method
  warning: (message: string, options?: any) => {
    return hotToast(message, {
      icon: '⚠️',
      style: {
        border: '1px solid #f59e0b',
        color: '#92400e',
        backgroundColor: '#fffbeb'
      },
      ...options
    });
  }
};

export default toast;